import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './legal-notices.component.html',
  styleUrls: ['./legal-notices.component.scss'],
})
export class LegalNoticesComponent implements OnInit {
  ngOnInit(): void {}
}
